<template>
  <div>
    <Alert type="warning" closable>
      {{$t('caseImport.precautionsTitle')}}
      <template slot="desc">
        <div>{{$t('caseImport.precautionsContent1')}} <a href="../../../../static/file/import.xlsx">{{$t('caseImport.downloadXlsx')}}</a></div>
        <div>{{$t('caseImport.precautionsContent2')}}</div>
        <div style="color: red;font-weight: bold;">{{$t('caseImport.precautionsContent3')}}</div>
        <div>{{$t('caseImport.precautionsContent4')}}</div>
      </template>
    </Alert>
    <Row>
      <Col span="14">
        <Card>
          <Upload
            type="drag"
            ref="uploadCarouselImage"
            :loading="uploadLoading"
            :on-format-error="handleFormatError"
            :before-upload="handleUpload"
            :on-success="handleSuccess"
            :on-error="uploadError"
            :format ="['xlsx','xls']"
            action="string">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p v-if="!fileName">{{$t('caseImport.uploadTip')}}</p>
              <div v-if="fileName">{{$t('caseImport.fileName')}}<span class="blueFont">{{ fileName }}</span></div>
            </div>
          </Upload>

          <Form ref="caseInfoForm" :model="caseInfoForm" label-position="left" :label-width="100" :rules="ruleCaseInfo">
            <Row type="flex" justify="space-around">
              <Col span="11">
                <FormItem :label="$t('addNewCase.caseInfo.caseType')" prop="pathologyType">
                  <Select class="inputWidth" v-model="caseInfoForm.pathologyType">
                    <Option v-for="item in bllxList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="11" offset="2">
                <FormItem :label="$t('addNewCase.caseInfo.inspectionDepartment')" prop="caseDepart">
                  <Select v-model="caseInfoForm.caseDepart" class="inputWidth" disabled>
                    <Option v-for="item in sjbmList" :value="item.label" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="space-around">
              <Col span="11">
                <FormItem :label="$t('addNewCase.caseInfo.sentToHospital')" prop="sendHospitalId">
                  <Select v-model="caseInfoForm.sendHospitalId">
                    <Option v-for="item in sendHospitalList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="11" offset="2">
                <FormItem
                  :label="$t('addNewCase.caseInfo.analysisType')"
                  prop="analysisType">
                  <Select v-model="caseInfoForm.analysisType">
                    <Option v-for="(item, index) in fxffList" :value="item.value" :key="index">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span="9" offset="1">
        <Card>
          <p slot="title" style="font-size: 12px" @click="exportData()"><a><Icon type="md-cloud-download" size="16"/>
            {{ $t('caseImport.export') }}</a></p>
          <div href="#" slot="extra">
            {{$t('caseImport.updateDateText')}} {{errorDataTime}}
          </div>
          <Table ref="table" stripe  border  :columns="columns" :data="errorDataList"></Table>
        </Card>
      </Col>
    </Row>
    <div style="text-align: left;margin-top: 30px" slot="footer">
        <Button  v-if="uploadingFile !== null" type="info" size="large" :loading="loadingStatus"  @click="uploadFun()">{{ loadingStatus ? this.$t('caseImport.uploading') : this.$t('caseImport.startUpload') }}</Button>
        <Button  v-if="caseIdList.length !== 0" type="info" size="large" :loading="loadingPrintStatus" @click="printTip()">{{ loadingPrintStatus ? this.$t('caseImport.printing') : this.$t('caseImport.startPrinting') }}</Button>
        <Button  v-if="caseIdList.length !== 0"  size="large" @click="cancelPrint()">{{$t('caseImport.cancelPrinting')}}</Button>
    </div>
  </div>
</template>

<script>
import {formatDate} from '../../../utils/date'
export default {
  name: 'CaseImport',
  data () {
    return {
      $vue: '',
      uploadingFile: null, // 待上传的文件
      fileName: '', // 待上传文件的名称
      uploadLoading: false, // 上传控件loading状态
      loadingStatus: false, // upload组件的状态
      loadingPrintStatus: false, // 打印状态
      sjbmList: '', // 送检部门
      bllxList: '', // 病例类型
      fxffList: '', // 分析方法
      sendHospitalList: [], // 送检医院列表
      errorDataList: [], // 返回未被导入的数据
      caseIdList: [], // 需要打印二维码的病例id
      errorDataTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      // 病例信息
      caseInfoForm: {
        userId: localStorage.getItem('userId' + localStorage.getItem('userName')), // 技术员id
        laboratoryId: localStorage.getItem('laboratoryId'),
        pathologyType: '', // 病例类型
        caseDepart: '', // 送检科室
        sendHospitalId: '', // 送检医院Id
        analysisType: '', // 分析类型
        slideDyeType: -1, // 染色类型
        caseType: -1 // 病理类型(1 细胞 2组织 )
      },
      responseData: [], // 响应的数据
      ruleCaseInfo: {
        pathologyType: [
          { required: true, message: this.$t('addNewCase.caseInfo.CaseTypeTip'), trigger: 'blur' }
        ],
        caseDepart: [
          { required: true, message: this.$t('addNewCase.caseInfo.inspectionDepartmentTip'), trigger: 'blur' }
        ],
        sendHospitalId: [
          { required: true, message: this.$t('addNewCase.caseInfo.sentToHospitalTip'), trigger: 'blur' }
        ],
        analysisType: [
          { required: true, message: this.$t('caseImport.analysisTypeTip'), trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: this.$t('caseImport.numberOfLines'),
          key: 'numberOfLines'
        },
        {
          title: this.$t('caseImport.errorMessage'),
          tooltip: true,
          key: 'message'
        }
      ]
    }
  },
  methods: {
    handleFormatError (file) {
      this.$Notice.warning({
        title: this.$t('caseImport.fileFormatTipTitle'),
        desc: this.$t('caseImport.fileFormatTipContent1') + file.name + this.$t('caseImport.fileFormatTipContent2')
      })
    },
    // 图片上传前
    handleUpload (file) {
      this.caseIdList = []
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        var formdata = new FormData()
        formdata.append('file', file)
        // 通过formdata.get('file')方法，可以取file文件里的信息，例如Excel的文件名。
        this.fileName = formdata.get('file').name
        // 注意：这个将作为参数传给接口实现上传。传给接口的file不需要 formdata.get('file')，直接传file。
        this.uploadingFile = formdata
      } else {
        this.$Notice.warning({
          title: this.$t('caseImport.fileFormatUploadTip'),
          desc: this.$t('caseImport.fileFormatUploadTipDesc1') + file.name + this.$t('caseImport.fileFormatUploadTipDesc2')
        })
      }
      return false
    },
    // 取消打印
    cancelPrint () {
      this.caseIdList = []
    },
    // 批量打印提示
    printTip () {
      this.$Modal.confirm({
        title: this.$t('caseImport.printTipConfirmTitle'),
        content: '<p style="color: red">' + this.$t('caseImport.printTipConfirmContent') + '</p>',
        okText: this.$t('caseImport.printTipConfirmOkText'),
        cancelText: this.$t('caseImport.printTipConfirmCancelText'),
        onOk: () => { this.print() }
      })
    },
    // 打印二维码
    print () {
      if (!this.loadingPrintStatus) {
        this.loadingPrintStatus = true
        for (let i = 0; i < this.caseIdList.length; i++) {
          console.log(this.caseIdList[i])
          // 执行打印二维码动作
          this.printCaseQrCode(this.caseIdList[i])
        }
        this.loadingPrintStatus = false
        this.caseIdList = []
        this.$Notice.success({
          title: this.$t('caseImport.printTipSucessTitle'),
          desc: this.$t('caseImport.printTipSucessDesc')
        })
      } else {
        this.$Notice.warning({
          title: this.$t('caseImport.printTipWarningTitle'),
          desc: this.$t('caseImport.printTipWarningDesc')
        })
      }
    },
    // 上传病例
    async uploadFun () {
      this.caseIdList = []
      if (!this.loadingStatus) {
        this.loadingStatus = true
        // 根据分析类型，获取染色类型，以及病理类型（细胞/组织)
        this.getSlideDyeTypeAndCaseType(this.caseInfoForm.analysisType)
        this.uploadingFile.append('caseVo', JSON.stringify(this.caseInfoForm))
        try {
          let res = await this.$http.post(this.$vue.getData('IMPORT_CASE'), this.uploadingFile)
          if (res.data.result === '1') {
            this.errorDataList = res.data.data.errorDataList
            this.caseIdList = res.data.data.caseIdList
            this.errorDataTime = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
            this.uploadingFile = null // 上传成功后，将上传文件置空
            this.fileName = ''
            this.$Notice.success({
              title: this.$t('caseImport.uploadFunSucessTitle'),
              desc: this.$t('caseImport.uploadFunSucessDesc')
            })
          }
        } catch (e) {
          this.$Notice.error({
            title: this.$t('caseImport.uploadFunErrorTitle'),
            desc: this.$t('caseImport.uploadFunErrorDesc')
          })
        }
        this.loadingStatus = false
      } else {
        this.$Notice.warning({
          title: this.$t('caseImport.uploadFunWarningTitle'),
          desc: this.$t('caseImport.uploadFunWarningDesc')
        })
      }
    },
    // 图片上传成功
    handleSuccess (res) {
      if (res.errcode === 0) {
        this.$Message.success(this.$t('caseImport.handleSuccessTip'))
      }
    },
    // 轮播图片上传失败
    uploadError () {
      this.$Message.error(this.$t('caseImport.uploadErrorTip'))
    },
    // 获取医院列表
    async getHospitalList () {
      let params = new URLSearchParams()
      let suc = await this.$http.post(this.$vue.getData('GET_HOSPITAL_LIST_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.sendHospitalList = data
        this.caseInfoForm.sendHospitalId = data[0].value
      }
    },
    // 获取字典表信息
    async getDicInfo () {
      let params = new URLSearchParams()
      // 证件类型，病理类型，送检部门，染色类型
      let types = 'bllx,sjbm,rslx,fxff'
      params.append('types', types)
      let suc = await this.$http.post(this.$vue.getData('GET_DIC_INFO_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.sjbmList = data.sjbm
        this.bllxList = data.bllx
        this.fxffList = data.fxff
        // 默认病例类型
        this.caseInfoForm.pathologyType = this.bllxList[0].value
        // 默认送检科室
        this.caseInfoForm.caseDepart = this.sjbmList[0].label
        // 默认分析类型
        this.caseInfoForm.analysisType = this.fxffList[0].value
      }
    },
    exportData () {
      if (this.errorDataList.length !== 0) {
        this.$refs.table.exportCsv({
          filename: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
        })
      } else {
        this.$Message.info(this.$t('caseImport.exportDataTip'))
      }
    },
    // 打印病例二维码
    async printCaseQrCode (caseId) {
      let params = new URLSearchParams()
      params.append('caseId', caseId)
      let suc = await this.$http.post(this.$vue.getData('PRINT_SLIDE_QRCODE_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        let IsMoreSlides = data.length > 1 ? 'true' : 'false'
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let code = ''
          if (IsMoreSlides) {
            code = item.slide_code
          } else {
            code = item.pathology_id
          }
          let qrcode = '@' + item.slide_id
          try {
            window.HandleEvent('print', code, qrcode)
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
        }
      }
      console.log(suc)
    },
    /**
     * @method       getSlideDyeTypeAndCaseType
     * @description  方法描述:获取染色类型，以及病理类型（细胞/组织)
     */
    getSlideDyeTypeAndCaseType (analysisType) {
      switch (analysisType) {
        case '1':
          this.caseInfoForm.slideDyeType = 1
          this.caseInfoForm.caseType = 1
          break
        case '2':
        case '9':
          this.caseInfoForm.slideDyeType = 2
          this.caseInfoForm.caseType = 1
          break
        case '3':
          this.caseInfoForm.slideDyeType = 3
          this.caseInfoForm.caseType = 1
          break
        case '5':
          this.caseInfoForm.slideDyeType = 5
          this.caseInfoForm.caseType = 1
          break
        case '4':
        case '6':
        case '7':
          this.caseInfoForm.slideDyeType = 4
          this.caseInfoForm.caseType = 2
          break
        case '8':
          this.caseInfoForm.slideDyeType = 7
          this.caseInfoForm.caseType = 1
          break
      }
    }
  },
  beforeMount () {
    this.$vue = this
    this.getDicInfo()
    this.getHospitalList()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/base/addCase/caseImport.vue